module.exports = __webpack_public_path__ + "static/media/Somaiya-white.bb8cd728.svg";